import { Component, OnInit } from '@angular/core';
import { ProjectService } from '../project.service'
import { RuntimeService } from '../runtime.service'

@Component({
  selector: 'app-project-dashboard',
  templateUrl: './project-dashboard.component.html',
  styleUrls: ['./project-dashboard.component.css']
})
export class ProjectDashboardComponent implements OnInit {

  constructor(
    public projects: ProjectService,
    private rts: RuntimeService
  ) { }

  ngOnInit() {
    this.rts.adminType = 'projects'
    this.rts.resetCurrentProject();
  }

}



// WEBPACK FOOTER //
// /GIT/Search-manager/rating-module/src/app/project-dashboard/project-dashboard.component.ts